package com.eladfinish.bible.contest.screens.pairMatching.ui

import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.IntrinsicSize
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.RowScope
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Card
import androidx.compose.material3.CardDefaults
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.tooling.preview.Preview
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.eladfinish.bible.contest.SharedRes
import com.eladfinish.bible.contest.darkGreen
import com.eladfinish.bible.contest.ic_move
import com.eladfinish.bible.contest.ui.components.buttons.ResourceIcon
import dev.icerock.moko.resources.compose.colorResource

@Composable
fun SortableItem(
    modifier: Modifier = Modifier,
    handleModifier: Modifier = Modifier,
    backgroundAlpha: Float = 0.5f,
    text: String,
    originalPosition: Int = 0,
    index: Int = 0,
    onItemClick: () -> Unit = {},
) {
    Card(
        modifier = modifier
            .fillMaxWidth()
            .height(IntrinsicSize.Min)
            .padding(vertical = 4.dp)
            .clickable(onClick = { onItemClick() }),
        shape = RoundedCornerShape(8.dp),
        colors = CardDefaults.cardColors(
            containerColor = when (index == originalPosition) {
                true -> colorResource(SharedRes.colors.darkGreen)
                false -> Color.White
            }.copy(alpha = backgroundAlpha),
        ),
        border = BorderStroke(1.dp, Color.White.copy(alpha = 0.5f)),
        elevation = CardDefaults.cardElevation(defaultElevation = 0.dp),
    ) {
        Row(
            modifier = Modifier
                .background(Color.Transparent)
                .padding(vertical = 4.dp),
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.SpaceBetween,
        ) {
            DragHandle(modifier = handleModifier)
            Text(
                modifier = Modifier
                    .weight(7f),
                text = text,
                textAlign = TextAlign.Center,
                color = Color.Black,
                style = MaterialTheme.typography.bodyLarge.copy(
                    fontSize = 18.sp
                ),
            )
            DragHandle(modifier = handleModifier)
        }
    }
}

@Composable
private fun RowScope.DragHandle(modifier: Modifier) {
    ResourceIcon(
        modifier = modifier
            .weight(weight = 1.5f)
            .size(size = 32.dp),
        imageResource = SharedRes.images.ic_move,
        tint = Color.Black
    )
}

@Preview
@Composable
private fun SortableItemLongPreview() {
    SortableItem(
        text = "הֲדַר וְשֵׁם עִירוֹ פָּעוּ וְשֵׁם אִשְׁתּוֹ מְהֵיטַבְאֵל בַּת־מַטְרֵד בַּת מֵי זָהָב",
    )
}
